import { theme } from "@huub-web/ui/theme/css/theme.css";
import { responsive, responsiveContainer } from "@huub-web/ui/utils/responsive";
import { rem } from "@huub-web/utils/css/rem";
import { style } from "@vanilla-extract/css";

const BREAKPOINT = 800;

export const containerStyle = style({
  height: `calc(100dvh - ${theme.spacings.xs} * 2)`,
  ...responsive({
    s: {
      height: `calc(100dvh - ${theme.spacings.s} * 2)`,
    },
    m: {
      height: `calc(100dvh - ${theme.spacings.m} * 2)`,
    },
    l: {
      height: `calc(100dvh - ${theme.spacings.l} * 2)`,
    },
  }),
});

export const observationsGridStyle = style({
  // Mobile: stack the header (illustration + title) above the observations.
  gridTemplateColumns: "1fr",
  gridTemplateRows: "auto minmax(0, 1fr)",
  flexGrow: 1,
  overflow: "hidden",
  ...responsiveContainer({
    [BREAKPOINT]: {
      gap: theme.spacings.m,
      gridTemplateColumns: "repeat(12, 1fr)",
      gridTemplateRows: "none",
    },
  }),
});

export const categoryMenuStyle = style({
  // Mobile: full-width header row, no sticky side list.
  gridColumn: "1 / -1",
  padding: `${theme.spacings.m} ${theme.spacings.m} 0 ${theme.spacings.m}`,
  ...responsiveContainer({
    [BREAKPOINT]: {
      gridColumn: "span 3",
      position: "sticky",
      top: 0,
      padding: `${theme.spacings.m} 0 ${theme.spacings.m} ${theme.spacings.m}`,
    },
  }),
});

/**
 * Sub-category navigation list, hidden on mobile where the side list is removed.
 */
export const subCategoryNavStyle = style({
  display: "none",
  ...responsiveContainer({
    [BREAKPOINT]: {
      display: "block",
      marginTop: theme.spacings.s,
    },
  }),
});

/**
 * Section illustration, hidden on mobile where only the title is shown.
 */
export const illustrationStyle = style({
  display: "none",
  ...responsiveContainer({
    [BREAKPOINT]: {
      display: "block",
    },
  }),
});

export const categoryContentStyle = style({
  gridColumn: "1 / -1",
  overflow: "hidden",
  height: "100%",
  ...responsiveContainer({
    [BREAKPOINT]: {
      gridColumn: "span 9",
    },
  }),
});

export const categoryContentFlexStyle = style({
  overflow: "hidden",
  height: "100%",
});

export const categoryContentContainerStyle = style({
  padding: theme.spacings.s,
  borderBottom: `1px solid ${theme.colors.defaultBorder}`,
  overflow: "hidden",
  ...responsiveContainer({
    [BREAKPOINT]: {
      padding: theme.spacings.m,
    },
  }),
  selectors: {
    "&:last-child": {
      borderBottom: "none",
    },
  },
});

export const cardWrapperStyle = style({
  ":last-child": {
    minHeight: `calc(var(--scrollpane-height) - ${theme.spacings.m})`,
  },
});

export const categoryContentHeaderStyle = style({
  padding: `${theme.spacings.m} ${theme.spacings.m} 0 ${theme.spacings.m}`,
  ...responsiveContainer({
    [BREAKPOINT]: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
    },
  }),
});

/**
 * Filter controls (search + assessment select). On mobile they share the row
 * 50/50 and wrap the reset button below; fixed width on larger screens.
 */
export const filterRowStyle = style({
  width: "100%",
  flexWrap: "wrap",
  ...responsiveContainer({
    [BREAKPOINT]: {
      width: "auto",
      flexWrap: "nowrap",
    },
  }),
});

/**
 * Close button shown next to the title on mobile (hidden on larger screens
 * where it lives inline in the filter header instead).
 */
export const titleRowCloseStyle = style({
  ...responsiveContainer({
    [BREAKPOINT]: {
      display: "none",
    },
  }),
});

/**
 * Close button shown inline in the filter header on larger screens only.
 */
export const headerCloseStyle = style({
  display: "none",
  ...responsiveContainer({
    [BREAKPOINT]: {
      display: "inline-flex",
    },
  }),
});

/**
 * Reset filters as a compact icon button on mobile only.
 */
export const resetIconWrapperStyle = style({
  display: "inline-flex",
  ...responsiveContainer({
    [BREAKPOINT]: {
      display: "none",
    },
  }),
});

/**
 * Reset filters as a full text button on larger screens only.
 */
export const resetButtonWrapperStyle = style({
  display: "none",
  ...responsiveContainer({
    [BREAKPOINT]: {
      display: "inline-flex",
    },
  }),
});

export const titleContainerStyle = style({
  padding: `${theme.spacings.s} ${theme.spacings.m} ${theme.spacings.l} 0`,
});
export const scrollPaneContainerStyle = style({
  height: "100%",
  overflow: "hidden",
});

export const scrollPaneContentStyle = style({
  padding: `0 ${theme.spacings.m} ${theme.spacings.m} ${theme.spacings.m}`,
});

export const rulerStyle = style({
  margin: `0 ${theme.spacings.m}`,
  width: `calc(100% - 2 * ${theme.spacings.m})`,
});

export const searchFieldStyle = style({
  // Mobile: grow to fill half the row; fixed width on larger screens.
  flexGrow: 1,
  flexShrink: 1,
  flexBasis: 0,
  minWidth: 0,
  ...responsiveContainer({
    [BREAKPOINT]: {
      width: rem(200),
      flexGrow: 0,
      flexShrink: 0,
      flexBasis: "auto",
    },
  }),
});

export const assessmentSelectStyle = style({
  flexGrow: 1,
  flexShrink: 1,
  flexBasis: 0,
  minWidth: 0,
  ...responsiveContainer({
    [BREAKPOINT]: {
      width: rem(200),
      flexGrow: 0,
      flexShrink: 0,
      flexBasis: "auto",
    },
  }),
});
